import { z } from 'my-zod'
import { outfitterOrderVehicleAllocationsModel } from '../../fleet-operations/vehicle-allocation'
import { outfitterOrderHeadersModel } from './outfitter-order-headers-model'
import { outfitterOrderLinesModel } from './outfitter-order-lines-model'
import { outfitterOrderWarehouseAllocationsModel } from './outfitter-order-warehouse-allocations-model'

export const outfitterOrderLineSystemView = outfitterOrderLinesModel.augment({
  vehicleAllocations: outfitterOrderVehicleAllocationsModel.array(),
  warehouseAllocations: outfitterOrderWarehouseAllocationsModel.array()
})
export type outfitterOrderLineSystemView = z.infer<typeof outfitterOrderLineSystemView>

export const outfitterOrderHeaderSystemView = outfitterOrderHeadersModel.augment({
  orderLines: outfitterOrderLineSystemView.array()
})
export type outfitterOrderHeaderSystemView = z.infer<typeof outfitterOrderHeaderSystemView>
